import ChatbotSVG from '../../../globalstyle/components/SVGs/Chatbot.svg';

const PwBotAvatar = (props) => {
  return (
    <div className={`chatbot-avatar ${props?.className || ''}`}>
      <img
        src={ChatbotSVG}
        alt="chatbot image"
        style={{ display: 'block' }}
        {...props}
      />
    </div>
  );
};

export default PwBotAvatar;